import gsap from 'gsap';

export const triggerAttribute = ( setting, timers, index ) => {
	let targets = [],
		keys = [],
		values = [],
		actions = [];
	setting?.settings?.forEach( ( ele, i ) => {
		targets[ i ] = document.querySelector( ele.target );
		keys[ i ] = ele.key;
		values[ i ] = ele.value;
		actions[ i ] = ele.action || 'set';
	} );

	const execute = () => {
		targets.forEach( ( ele, i ) => {
			if ( ele ) {
				if ( actions[ i ] === 'remove' ) {
					ele.removeAttribute( keys[ i ] );
				} else {
					ele.setAttribute( keys[ i ], values[ i ] );
				}
			}
		} );
	};

	const run = () => {
		timers[ index ]?.kill();
		timers[ index ] = null;
		if ( setting.delay ) {
			timers[ index ] = gsap.delayedCall( setting.delay, execute );
		} else {
			execute();
		}
	};

	const kill = () => {
		targets = [];
		keys = [];
		values = [];
		actions = [];
	};

	return { run, kill };
};
